module.exports = __webpack_public_path__ + "static/media/goods13.569e92af.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods13.png
// module id = 438
// module chunks = 0